import { IHappyHourTemplate } from '../interfaces';

type IHappyHourEditBoard = IHappyHourTemplate & { index?: number; id?: string };

export const dehydrateFormData = (formData: IHappyHourTemplate): { happyHourData: IHappyHourTemplate } => {
	const happyHourData: IHappyHourTemplate = {
		...formData
	};
	return { happyHourData };
};

export const hydrateHappyHourFormData = (data: IHappyHourTemplate): IHappyHourTemplate => {
	const hydratedHappyHourData: IHappyHourEditBoard = {
		...data
	};
	delete hydratedHappyHourData.index; // which is formed on frontend
	delete hydratedHappyHourData.id; // which is formed on frontend

	return hydratedHappyHourData;
};
